"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = Cut;

var _Cut = require("@adobe/react-spectrum-workflow/dist/Cut");

var _icon = require("@react-spectrum/icon");

var _react = _interopRequireDefault(require("react"));

function Cut(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.Icon, props, /*#__PURE__*/_react.default.createElement(_Cut.A4uCut, null));
}